class KlaviyoForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector("form");
    this.input = this.querySelector('input[type="email"]');
    this.btn = this.querySelector('button[type="submit"]');
    this.msg = this.querySelector("[data-klaviyo-message]");
    this.companyId = this.dataset.companyId;
    this.listId = this.dataset.listId;
    if (!this.form || !this.companyId || !this.listId) return;
    this.form.addEventListener("submit", (e) => this.handleSubmit(e));
  }
  async handleSubmit(e) {
    e.preventDefault();
    const email = this.input.value;
    const originalText = this.btn.textContent;
    this.btn.disabled = true;
    this.btn.textContent = "...";
    try {
      const res = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${this.companyId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "revision": "2024-02-15"
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              custom_source: this.dataset.source || "Website",
              profile: {
                data: {
                  type: "profile",
                  attributes: { email }
                }
              }
            },
            relationships: {
              list: {
                data: { type: "list", id: this.listId }
              }
            }
          }
        })
      });
      if (res.ok || res.status === 202) {
        this.showMessage(this.dataset.msgSuccess || "Successfully subscribed!", "success");
        this.input.value = "";
      } else {
        throw new Error("Subscription failed");
      }
    } catch (err) {
      this.showMessage(this.dataset.msgError || "Something went wrong. Please try again.", "error");
    }
    this.btn.disabled = false;
    this.btn.textContent = originalText;
  }
  showMessage(text, type) {
    if (!this.msg) return;
    this.msg.textContent = text;
    this.msg.classList.remove("hidden", "text-green-300", "text-red-400");
    this.msg.classList.add(type === "success" ? "text-green-300" : "text-red-400");
    setTimeout(() => this.msg.classList.add("hidden"), 5e3);
  }
}
window.customElements.define("klaviyo-form", KlaviyoForm);
